import React from "react";
import { Navigate } from "react-router-dom";
import { isProyectosAdminRole } from "../../utils/proyectosAdmin";

type AdminProyectosRouteProps = {
  element: React.ReactElement;
};

const AdminProyectosRoute: React.FC<AdminProyectosRouteProps> = ({ element }) => {
  const authed = !!localStorage.getItem("authToken");
  if (!authed) return <Navigate to="/" replace />;
  if (!isProyectosAdminRole()) return <Navigate to="/dashboard" replace />;
  return element;
};

export default AdminProyectosRoute;
